import 'Styles/layout/theme.scss';
import 'swiper/swiper-bundle.css';

// Global Files
import Image from '../components/image';
import Swiper from '../components/swiper';
import Overlay from '../components/overlay';
import Header from '../components/header';
import MobNav from '../components/mobile-nav';
import Accor from '../components/accor';
import Animation from '../components/animation';

// Global Vue Directory
import Cart from '../vue/cart/cart';
import MiniCart from '../vue/cart/mini-cart';
import GlobalDrawer from '../vue/drawer/index';
import GlobalSearch from '../vue/search/index';
import Wishlist from '../vue/wishlist/wishlist';

Image();
Swiper();
Overlay();
Header();
MobNav();
Accor();
Animation();
Cart();
MiniCart();
GlobalDrawer();
GlobalSearch();
Wishlist();

window.header.init();
window.mobileNavigation.init()